module.exports = __webpack_public_path__ + "static/img/footr-qr.27f2418.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/image/qr/footr-qr.png
// module id = 07t/
// module chunks = 1